import { useState } from 'react'
import { vasOperations } from '../../../constants/operation'
import { useApproveVa } from '../../../services/react-query/report/due-payments'

const useDuePayments = () => {
    const { mutate: approveVa, isLoading: approveVaIsLoading } = useApproveVa()


    const modalInitial = {
        action: null,
        open: false,
        data: null,
    }
    const [modal, setModal] = useState(modalInitial)


    const onOptionClicked = (idx, item) => {
        setModal({
            data: item,
            open: true,
            action: vasOperations[idx],
        })
    }

    const onModalClose = () => {
        if (modal.open) {
            setModal(modalInitial)
        }
    }

    const getVasOperation = (vas) => {
        if (vas) {
            return !vas.isOperational ? vasOperations : []
        }
        return []
    }

    const handleApprove = () => {

        approveVa(modal.data._id, {
            onSuccess: () => {
                setModal(modalInitial)
            }
        })
    }

    return {
        onOptionClicked,
        modal,
        onModalClose,
        getVasOperation,
        handleApprove,
        approveVaIsLoading
    }
}

export default useDuePayments
